import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { get_extract_entity_fields_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { EXTRACT_ENTITY_FIELDS_KEY } from '@/utils/queryKeys.ts';
import { ExtractEntityFields } from '@/types/extract.ts';

const useRetrieveExtractEntityFields = (
  extractEntityId?: string,
): UseQueryResult<ExtractEntityFields, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery({
    queryKey: EXTRACT_ENTITY_FIELDS_KEY(automationId, extractEntityId),
    queryFn: async () => {
      const response = await apiClient.get(get_extract_entity_fields_url(extractEntityId));
      return response.data;
    },
    enabled: !!extractEntityId,
  });
};

export default useRetrieveExtractEntityFields;
